import React from 'react';
import { useAppSelector } from '@/store/hooks';

export const DefaultHeader: React.FC = () => {
  const local = useAppSelector((s) => s.local);
  const title = local.roomName || local.roomId || '';

  const isRenewal = window.location.pathname.indexOf('video-renewal') > -1;

  return (
    <div id="header" className="header rtcCustoms_headerReset">
      <div className="rtc_header rtc_header--white">
        <div className="main_title">
          <h1>
            {isRenewal ? (
              <img src="https://static.wehago.com/imgs/common/wehago_b.svg" width={109} height={22} alt="WEHAGO" />
            ) : (
              <img
                src="https://static.wehago.com/imgs/common/wehago_logo.png"
                width={109}
                height={22}
                alt="WEHAGO"
              />
            )}
          </h1>
        </div>
        <div className="service_title" title={title}>
          <h2
            className="nko_font rtcCustoms_headerTitle rtcCustoms_headerTitle--wide"
          >
            {title}
          </h2>
        </div>
        <div className="horizon_gnb"></div>
      </div>
    </div>
  );
};

export default DefaultHeader;
